import React, { useEffect, useState } from "react";
import "../SelfAssessment.css";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import { SubjectIcon } from "../../../SubjectIcon";
import { useNavigate } from "react-router-dom";
import { shortenParagraph } from "../../../utils/Engagement";
import { Tooltip } from "@mui/material";

export default function PendingSA({ filter, newSelfAssment }) {
  const [pending, setPending] = useState({
    question: false,
    homeworkId: null,
  });

  const navigate = useNavigate()
  const [pendingCard, setPendingCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [pendingSelfAssessment, setPendingSelfAssessment] = useState([]);
  const [noContentClick, setNoContentClick] = useState(false);
  const [previousData, setPreviousData] = useState([]);
  const [summarySideMenu, setSummarySideMenu] = useState(null);
  const today = moment().format("YYYY-MM-DD");
  const summarySideMenuActive = localStorage.getItem("summarySideMenu");
  const footerActive = localStorage.getItem("footerActive");

  const getPendingSA = async () => {
    try {
      let response = await axios.get(
        `/selfAssess/filterByStudentId/${currentUser?.id}/pending?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
        `${filter?.date
          ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
          : ``
        }` +
        `${filter?.time ? `&time=${filter?.time}` : ``}` +
        `${filter?.subjectId?.length !== 0
          ? `&subjectId=${filter?.subjectId}`
          : ``
        }`
      );

      response && setPendingSelfAssessment(response.data.data);
      setPendingCard(response.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (summarySideMenuActive == "SelfAssessment" && footerActive == "DCM") {
      setSummarySideMenu(summarySideMenuActive);
    } else {
      localStorage.setItem("summarySideMenu", null)
    }
  }, [])

  useEffect(() => {
    setIsGettingData(true);
    setPendingCard([]);
    getPendingSA();
  }, [filter, newSelfAssment]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleQuestionfalse = () => {
    setPending({
      ...pending,
      question: false,
    });
  };

  // console.log(moment.utc(previousData[0]?.deadline).local().isBefore(new Date), new Date())

  return (
    <div>
      {pendingCard && pendingCard.length > 0 ? (
        <div>

          <div className="d-flex gap-4 mt-3 flex-wrap">
            {pendingSelfAssessment &&
              pendingSelfAssessment.length > 0 &&
              pendingSelfAssessment.map((item, index) => (
                <div
                  key={index}
                  // className="summarySubBoxContainerHW summarySubBoxContainerSA"
                  className="w-80 h-[17.5rem] d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                  style={{
                    borderTop: `2px solid #8D4B28`
                  }}
                  onClick={(e) => {
                    setPending({
                      ...pending,
                      question: true,
                      homeworkId: item?.id,
                    });
                    navigate(`/publishedSelfAssessment`, {
                      state: { "selfAssessmentId": item?.id }
                    });
                  }}
                >
                  <div
                    className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                  >
                    <div>
                      <div className="subboxSubjectName">
                        {item?.subject?.name ?? " "}
                      </div>
                    </div>
                    <div>
                      <img
                        src={`${SubjectIcon?.find(
                          (i) => i.subjectName === item?.subject?.name
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="SubsummarySubBoxContainer"
                    style={{ paddingTop: "0" }}
                  >
                    <div className="headingOfHW" title={item?.name}>
                      {item?.name}
                    </div>
                    <div>
                      <span className="deadline">Created</span> &nbsp;
                      <span className="deadlineDate">
                        {timeHelper(item?.created_at)}
                      </span>
                    </div>
                    <div>
                      <span className="deadline">Book : </span> &nbsp;
                      <span className="deadlineDate">
                        <Tooltip
                          title={item?.book !== "Auto" ? item?.book?.name : item?.book}
                          arrow
                          placement="top"
                          enterDelay={200}
                          leaveDelay={100}
                        >
                          <span className="">
                            {item?.book !== "Auto" ? shortenParagraph(item?.book?.name, 30) : shortenParagraph(item?.book, 30)}
                          </span>
                        </Tooltip>
                      </span>
                    </div>
                    <div>
                      <span className="deadline">Chapter : </span> &nbsp;
                      <span className="deadlineDate">
                        <Tooltip
                          title={item?.chapter !== "Auto" ? item?.chapter?.name : item?.chapter}
                          arrow
                          placement="top"
                          enterDelay={200}
                          leaveDelay={100}
                        >
                          <span className="">
                            {item?.chapter !== "Auto" ? shortenParagraph(item?.chapter?.name, 30) : shortenParagraph(item?.chapter, 30)}
                          </span>
                        </Tooltip>
                      </span>
                    </div>
                    <div>
                      <span className="deadline">Skill : </span> &nbsp;
                      <span className="deadlineDate">
                        {item?.knowledgeSkill !== "Auto" ? item?.knowledgeSkill?.name : item?.knowledgeSkill}
                      </span>
                    </div>
                    <div>
                      <span className="deadline">Difficulty : </span> &nbsp;
                      <span className="deadlineDate">
                        {item?.difficultyLevel !== "Auto" ? item?.difficultyLevel?.name : item?.difficultyLevel}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <span>Self Assessment Not Found</span>
        // : noContentClick ? (
        //   <span>Homework Not Found</span>
        // ) : (
        //   <FilterNotFound setNoContentClick={setNoContentClick} />
      )}
    </div>
  );
}
